// Cápsulas de autocapacitación: el catálogo vive en /capsulas/catalogo.json
// (lo arma scripts/capsulas/publicar.js y lo sube subir.sh), así que agregar o
// regrabar una cápsula no pide desplegar el panel.

export type Capsula = {
  num: string; titulo: string; ruta: number; roles: string[]; prueba: boolean; resumen: string;
  duracion: number; video: string; poster: string; subtitulos: string | null;
};
export type Catalogo = { rutas: Record<string, { titulo: string; descripcion: string }>; venta: string[]; capsulas: Capsula[] };

let pendiente: Promise<Catalogo> | null = null;
export function cargarCatalogo(): Promise<Catalogo> {
  if (!pendiente) {
    pendiente = fetch('/capsulas/catalogo.json', { cache: 'no-cache' })
      .then((r) => { if (!r.ok) throw new Error('sin catálogo'); return r.json(); })
      .catch((e) => { pendiente = null; throw e; });
  }
  return pendiente;
}

/** La ve este rol: sin roles en el catálogo, la ven todos. */
export const paraRol = (c: Capsula, rol: string) => c.roles.length === 0 || c.roles.includes(rol);

export const duracionTexto = (s: number) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;

// Lo que ya vio cada persona. Queda en su navegador: es solo una ayuda para
// saber qué le falta (decisión de Jans, 12-oct-2026: cada uno ve lo suyo).
const clave = (uid: string) => `capsulas-vistas-${uid}`;
export function vistas(uid: string): Set<string> {
  try { return new Set(JSON.parse(localStorage.getItem(clave(uid)) || '[]')); } catch { return new Set(); }
}
export function marcarVista(uid: string, num: string) {
  try { const v = vistas(uid); v.add(num); localStorage.setItem(clave(uid), JSON.stringify([...v])); } catch { /* sin almacenamiento */ }
}

/** Qué cápsula explica cada sección del panel (botón "Cómo se usa"). */
export const CAPSULA_DE_VISTA: Record<string, string> = {
  casos: '1.3', caso: '1.4', nuevo: '1.1', notificaciones: '2.2', calendario: '2.4',
  usuarios: '4.1', reportes: '4.5', flujocaja: '4.6', captadoras: '4.8', asistencia: '4.9',
  foro: '6.1', plantillas: '4.3', importar: '0.4', configuracion: '4.2', asistente: '5.2',
};
